import {
  EvaluationEvent,
  UpdateEvaluationEventDto,
} from '@keyops-cep/api-client';

import { apiClient } from './swagger-codegen-api-config';

export const getEvaluationEventById = async (eventId: string) => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerFindOne(
        eventId
      );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAllEvaluationEvents = async () => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerFindAll();
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateEvaluationEventById = async (
  evaluationEventId: string,
  newEvaluationEventData: UpdateEvaluationEventDto
): Promise<EvaluationEvent> => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerUpdate(
        newEvaluationEventData,
        evaluationEventId
      );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getEvaluationEventQRCode = async (eventId: string) => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerGetQrCode(
        eventId
      );
    return res.data.dataUrl;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const generateEvaluationEventQRCodePdf = async (eventId: string) => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerGenerateQrCodePdf(
        eventId,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        {
          responseType: 'blob',
        }
      );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const refreshEvaluationEventResponses = async (eventId: string) => {
  try {
    const res =
      await apiClient.evaluationEventsApi.evaluationEventControllerRefreshResponses(
        eventId
      );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
